import React from "react";

import moment from "moment";

const RRChecklistReg = ({check, verDetalles, setShowInfo, handleShowInfo}) =>{

    return <div>
    <div className='container-r-list-item'>
        <div className='container-r-list-item-header'>
            <div className='r-list-item-header-clave'>{check.codigo} - {check.checkNro}</div>
            <div className='r-list-item-header-title'>{check.name} - {check.nameActivo}</div>
        </div>
        <div className='container-r-list-item-details'>
            <div className='r-list-item-details-title'>Fecha de Alta: {moment(check.fecAlt).format('DD-MM-YYYY HH:MM')}</div>
            <div className='r-list-item-details-title'>Usuario: {check.userName}</div>
            <div className='r-list-item-details-title'>Controles Fallidos: {check.controles.some(c => c.checked == 'negative') ? <label className="ctrlsFallidosLabel">{check.controles.filter(c => c.checked == 'negative').length}</label> : <label className="ctrlsExitososLabel">0</label>} </div>
        </div>
        <div className='container-r-list-item-btn'>
            <div className='r-list-item-btn-A' onClick={() => handleShowInfo(check)}>Detalles</div>
        </div>
    </div>
</div>
}

export default RRChecklistReg;